import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { base64Images } from '../../assets/base64Images';
import './MyPageOptimized.css';

const MyPage: React.FC = () => {
  const { logout, user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleUserInfoClick = () => {
    if (isAuthenticated) {
      navigate('/my/profile');
    } else {
      navigate('/login');
    }
  };

  const handleOrdersClick = (status: string) => {
    // Convert to design document parameter format
    const statusMap: { [key: string]: string } = {
      'confirmed': '2',  // 已付款/待上课
      'refund': '4',     // 退款/售后
      'all': '0'         // 全部
    };
    navigate(`/my/orders?status=${statusMap[status] || '0'}`);
  };

  const handleCouponsClick = () => {
    navigate('/my/coupons');
  };

  const handleAddressClick = () => {
    navigate('/my/address');
  };

  const handleMyCourseClick = () => {
    navigate('/my/courses');
  };

  const handleTransferClick = () => {
    navigate('/my/transfer');
  };

  const handleRenewClick = () => {
    navigate('/my/renew');
  };

  const handleCalendarClick = () => {
    navigate('/my/calendar');
  };

  return (
    <div className="xlx-my-page">
      {/* Header */}
      <div className="xlx-header-sticky">
        <div className="xlx-header-fixed-box">
          <div className="left"></div>
          <div className="center">我的</div>
        </div>
      </div>
      <div className="my-info-detail-box">
        {/* User Info Section */}
        <div className="user-info" onClick={handleUserInfoClick} style={{cursor: 'pointer'}}>
          <div className="avatar-box">
            <div className="avatar">
              <img 
                src={base64Images.avatar} 
                alt="用户头像" 
              />
            </div>
          </div>
          <div className="login-info">
            {isAuthenticated ? (
              <>
                <div className="name">{user?.realName || user?.username || '用户名称'}</div>
                <div className="detail">查看并编辑个人资料</div>
              </>
            ) : (
              <>
                <div className="name">未登录</div>
                <div className="detail">点击登录</div>
              </>
            )}
          </div>
          <div className="van-icon van-icon-arrow"></div>
        </div>

{isAuthenticated ? (
          <>
            {/* Order Info Section */}
            <div className="order-info">
              <div className="title">我的订单</div>
              <div className="list">
                <div className="item" onClick={() => handleOrdersClick('confirmed')} style={{cursor: 'pointer'}}>
                  <div className="icon">
                    <img src={base64Images.toClass} alt="已付款" />
                  </div>
                  <div className="name">已付款</div>
                </div>
                <div className="item" onClick={() => handleOrdersClick('refund')} style={{cursor: 'pointer'}}>
                  <div className="icon">
                    <img src={base64Images.refund} alt="已退款" />
                  </div>
                  <div className="name">已退款</div>
                </div>
                <div className="item" onClick={handleAddressClick} style={{cursor: 'pointer'}}>
                  <div className="icon">
                    <img src={base64Images.address} alt="收货地址" />
                  </div>
                  <div className="name">收货地址</div>
                </div>
              </div>
            </div>

            {/* Services Section */}
            <div className="services-info">
              <div className="title">学习服务</div>
              <div className="services-grid">
                <div className="service-item" onClick={handleMyCourseClick} style={{cursor: 'pointer'}}>
                  <div className="service-icon">
                    <img src={base64Images.myCourses} alt="我的课程" />
                  </div>
                  <div className="service-name">我的课程</div>
                </div>
                <div className="service-item" onClick={handleTransferClick} style={{cursor: 'pointer'}}>
                  <div className="service-icon">
                    <img src={base64Images.transfer} alt="调课/转班" />
                  </div>
                  <div className="service-name">调课/转班</div>
                </div>
                <div className="service-item" onClick={handleRenewClick} style={{cursor: 'pointer'}}>
                  <div className="service-icon">
                    <img src={base64Images.renew} alt="续报中心" />
                  </div>
                  <div className="service-name">续报中心</div>
                </div>
              </div>
            </div>
            <div className="logout-btn">
              <button 
                className="van-button van-button--primary" 
                onClick={handleLogout}
              >
                退出登录
              </button>
            </div>
          </>
        ) : (
          <div className="login-section">
            <div className="login-btn">
              <button 
                className="van-button van-button--primary" 
                onClick={handleLogin}
              >
                登录
              </button>
            </div>
            <div className="login-tip">
              <p>登录后可查看和管理您的课程</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyPage;